import {Component, inject, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MaterialModule} from '../../../../../core/modules/material.module';
import {SharedModule} from '../../../../../core/modules/shared.module';
import {CertificateTemplateService} from '../../../../../core/services/certificateTemplate.service';
import {catchError, finalize, forkJoin, of, tap} from 'rxjs';
import {NgxSpinnerComponent, NgxSpinnerService} from 'ngx-spinner';

interface CertificateRecipient {
  frontUserId: number;
  frontUser?: {firstName: string; lastName: string};
  sent?: boolean;
  failed?: boolean;
}

interface SendCertificateData {
  users: CertificateRecipient[];
  eventId: number;
}

@Component({
  selector: 'send-certificate-component',
  templateUrl: './send-certificate.component.html',
  styleUrls: ['./send-certificate.component.scss'],
  standalone: true,
  imports: [MaterialModule, SharedModule, NgxSpinnerComponent],
  providers: [CertificateTemplateService]
})
export class SendCertificateComponent {
  spinner = inject(NgxSpinnerService);
  users: CertificateRecipient[];
  blockButton = false;
  closeButton = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: SendCertificateData,
              public dialogRef: MatDialogRef<SendCertificateComponent>,
              private certificateTemplateService: CertificateTemplateService) {
    this.users = data.users.filter(user => !!user.frontUserId)
      .map(user => ({...user, sent: false, failed: false}));
  }

  sendCertificates(): void {
    if (this.blockButton || this.closeButton || !this.users.length) {
      return;
    }
    this.spinner.show('sendCertificateComponent');
    this.blockButton = true;
    this.dialogRef.disableClose = true;
    const requests = this.users.map(user =>
      this.certificateTemplateService.sendEventCertificate(+user.frontUserId, +this.data.eventId).pipe(
        tap(() => user.sent = true),
        catchError(() => {
          user.failed = true;
          return of(null);
        })
      )
    );

    forkJoin(requests).pipe(
      finalize(() => {
        this.blockButton = false;
        this.closeButton = true;
        this.dialogRef.disableClose = false;
        this.spinner.hide('sendCertificateComponent');
      })
    ).subscribe();
  }
}
